import { atom, Provider, useAtomValue, useSetAtom } from 'jotai';

/**
 * 선택형 문제 AI 생성 인덱스 관리
 */
const generatingIndexesAtom = atom<number[]>([]);
/**
 * 선택형 문제 AI 생성 벌크 상태 관리
 */
const isGeneratingBulkAtom = atom<boolean>(false);

/**
 * 선택형 문제 AI 생성 인덱스 관리
 */
export const useSetAiGenerateMultipleStatus = () => {
  const setGeneratingIndexes = useSetAtom(generatingIndexesAtom);
  const setIsGeneratingBulk = useSetAtom(isGeneratingBulkAtom);
  const addIndex = (index: number) => {
    setGeneratingIndexes(prev => [...prev, index]);
  };
  const removeIndex = (index: number) => {
    setGeneratingIndexes(prev => prev.filter(i => i !== index));
  };
  return {
    addIndex,
    removeIndex,
    setIsGeneratingBulk
  };
};
export const useAiGenerateMultipleStatusValue = () => {
  const generatingIndexes = useAtomValue(generatingIndexesAtom);
  const isGeneratingBulk = useAtomValue(isGeneratingBulkAtom);
  return {
    generatingIndexes,
    isGeneratingBulk
  };
};
export const AiGenerateMultipleStatusProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <Provider data-sentry-element="Provider" data-sentry-component="AiGenerateMultipleStatusProvider" data-sentry-source-file="useAiGenerateMultipleStatus.tsx">{children}</Provider>;
};